/**
 * Authenticated API fetch wrapper for OpenTool.
 * Auto-injects Authorization + X-Opentool-Org headers.
 * On 401, clears token and reloads to trigger login flow.
 */

function getApiBase(): string {
  const params = new URLSearchParams(window.location.search);
  const custom = params.get('backend');
  if (custom) return custom.replace(/\/$/, '');
  const host = window.location.hostname;
  if (host.endsWith('.github.io') || host.endsWith('.pages.dev') || host.endsWith('.netlify.app')) {
    return 'http://localhost:9900';
  }
  return '';
}

export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const base = getApiBase();
  const token = localStorage.getItem('opentool_token');
  const activeOrg = localStorage.getItem('opentool_active_org');

  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (activeOrg) {
    headers.set('X-Opentool-Org', activeOrg);
  }
  if (!headers.has('Content-Type') && options.body && typeof options.body === 'string') {
    headers.set('Content-Type', 'application/json');
  }

  const resp = await fetch(`${base}${path}`, {
    ...options,
    headers,
  });

  if (resp.status === 401) {
    localStorage.removeItem('opentool_token');
    localStorage.removeItem('opentool_active_org');
    window.location.hash = '';
    window.location.reload();
  }

  return resp;
}

export async function apiJson<T = unknown>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const resp = await apiFetch(path, options);
  return resp.json();
}
